export class AmountCannotBeLessThanAccumulatedException extends Error {
  protected _code: string;

  constructor() {
    super("Amount cannot be less than the accumulated amount.");

    this.name = "AmountCannotBeLessThanAccumulatedException";
    this._code = "amountCannotBeLessThanAccumulated";
  }
}
